import React from 'react';
function Article({ ...r }) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 20" {...r}>
			<path
				fill="#272727"
				d="M17 20H1a1 1 0 01-1-1V1a1 1 0 011-1h16a1 1 0 011 1v18a1 1 0 01-1 1zm-1-2V2H2v16h14zM4 4h4v4H4V4zm0 6h10v2H4v-2zm0 4h10v2H4v-2zm6-9h4v2h-4V5z"
			></path>
		</svg>
	);
}

export default Article;
